<mat-card appearance="outlined">
  <div class="row">
    <div class="col">
      <p>
        <strong>{{ message }}</strong>
      </p>
      <p class="text-muted">
        Esta acción marcará el concepto como eliminado y desasignará todo el personal relacionado.
      </p>
      <div class="d-flex justify-content-center flex-column flex-md-row">
        <button mat-stroked-button (click)="delete()" class="me-0 me-md-2 mb-2 mb-md-0" [tabIndex]="-1">
          <mat-icon>delete</mat-icon>
          Eliminar
        </button>
        <button mat-stroked-button (click)="closeDialog()" [tabIndex]="-1">
          <mat-icon>close</mat-icon>
          Cancelar
        </button>
      </div>
    </div>
  </div>
</mat-card>
